var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-weather"},[(_vm.currentWeather)?_c('main-info',{attrs:{"currentWeather":_vm.currentWeather}}):_vm._e(),(_vm.currentWeather)?_c('additional-info',{attrs:{"currentWeather":_vm.currentWeather}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }